(function () {
  "use strict";

  function getGrid(viewport) {
    return viewport.querySelector("[data-related-track], .hrc-product-grid");
  }

  function scrollStep(grid) {
    var item = grid.querySelector(".hrc-related-grid-item");
    if (!item) return grid.clientWidth * 0.75;
    var styles = getComputedStyle(grid);
    var gap = parseFloat(styles.columnGap || styles.gap || 0) || 0;
    return item.getBoundingClientRect().width + gap;
  }

  function updateNav(viewport) {
    var grid = getGrid(viewport);
    var prev = viewport.querySelector("[data-related-prev]");
    var next = viewport.querySelector("[data-related-next]");
    if (!prev || !next) return;

    if (!grid) {
      viewport.classList.remove("is-scrollable");
      prev.disabled = true;
      next.disabled = true;
      return;
    }

    var max = Math.max(0, grid.scrollWidth - grid.clientWidth);
    var x = grid.scrollLeft;
    var scrollable = max > 2;
    var atStart = x <= 2;
    var atEnd = x >= max - 2;

    viewport.classList.toggle("is-scrollable", scrollable);
    prev.disabled = !scrollable || atStart;
    next.disabled = !scrollable || atEnd;
    prev.setAttribute("aria-disabled", prev.disabled ? "true" : "false");
    next.setAttribute("aria-disabled", next.disabled ? "true" : "false");
  }

  function bindGrid(viewport, grid) {
    if (!grid || grid.dataset.relatedScrollBound === "1") {
      updateNav(viewport);
      return;
    }
    grid.dataset.relatedScrollBound = "1";

    grid.addEventListener(
      "scroll",
      function () {
        updateNav(viewport);
      },
      { passive: true },
    );

    grid.addEventListener("keydown", function (e) {
      if (e.key === "ArrowRight") {
        e.preventDefault();
        grid.scrollBy({ left: scrollStep(grid), behavior: "smooth" });
      } else if (e.key === "ArrowLeft") {
        e.preventDefault();
        grid.scrollBy({ left: -scrollStep(grid), behavior: "smooth" });
      }
    });

    updateNav(viewport);
  }

  function bindViewport(viewport) {
    var prev = viewport.querySelector("[data-related-prev]");
    var next = viewport.querySelector("[data-related-next]");
    if (!prev || !next) return;

    if (viewport.dataset.relatedBound !== "1") {
      viewport.dataset.relatedBound = "1";

      prev.addEventListener("click", function () {
        var grid = getGrid(viewport);
        if (!grid || prev.disabled) return;
        grid.scrollBy({ left: -scrollStep(grid), behavior: "smooth" });
      });

      next.addEventListener("click", function () {
        var grid = getGrid(viewport);
        if (!grid || next.disabled) return;
        grid.scrollBy({ left: scrollStep(grid), behavior: "smooth" });
      });
    }

    bindGrid(viewport, getGrid(viewport));
  }

  function initRelatedSlider(section) {
    var viewport = section.querySelector("[data-related-viewport]");
    if (!viewport) return;

    bindViewport(viewport);

    var rec = viewport.querySelector("product-recommendations");
    if (rec && rec.dataset.relatedObserved !== "1") {
      rec.dataset.relatedObserved = "1";
      var observer = new MutationObserver(function () {
        bindGrid(viewport, getGrid(viewport));
      });
      observer.observe(rec, { childList: true });
    }
  }

  function initAll() {
    document
      .querySelectorAll("[data-related-products-section]")
      .forEach(initRelatedSlider);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", initAll);
  } else {
    initAll();
  }

  window.addEventListener(
    "resize",
    function () {
      document.querySelectorAll("[data-related-viewport]").forEach(updateNav);
    },
    { passive: true },
  );

  document.addEventListener("shopify:section:load", function (event) {
    var section = event.target.querySelector("[data-related-products-section]");
    if (!section) return;
    var viewport = section.querySelector("[data-related-viewport]");
    if (viewport) delete viewport.dataset.relatedBound;
    var rec = section.querySelector("product-recommendations");
    if (rec) delete rec.dataset.relatedObserved;
    initRelatedSlider(section);
  });
})();
